'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestStripeToken = undefined;

var _stripeService = require('./stripeService');

var _formActions = require('../formActions');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var requestStripeToken = exports.requestStripeToken = function requestStripeToken(formFields, dispatch) {
    return new Promise(function (resolve, reject) {
        var _formFields$form = formFields.form,
            form = _formFields$form === undefined ? 'payment' : _formFields$form,
            number = formFields.number,
            expiry = formFields.expiry,
            cvc = formFields.cvc,
            cardName = formFields.cardName,
            postcode = formFields.postcode;


        var handleError = function handleError(_ref) {
            var error = _ref.error;

            if (error.type !== 'card_error') {
                return reject(dispatch((0, _formActions.formSubmissionFailed)({
                    form: form,
                    primaryError: {
                        message: error.message
                    }
                })));
            }

            var fieldName = error.param;

            if (fieldName === 'exp_year' || fieldName === 'exp_month') fieldName = 'expiry';

            var errorOb = _defineProperty({}, fieldName, {
                message: error.message,
                type: 'ERROR'
            });

            return reject(errorOb);
        };

        var onTokenResponse = function onTokenResponse(status, response) {
            if (response.error) return handleError(response);
            resolve({ token: response });
        };

        (0, _stripeService.getStripe)().card.createToken({
            name: cardName,
            number: number,
            exp: expiry,
            cvc: cvc,
            address_zip: postcode
        }, onTokenResponse);
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/creditCard/creditCardActions.js
// module id = 1773
// module chunks = 0